import { LAYOUT_PAGE__open_auth_if_no_auth_token } from '@/page_wrappers/LAYOUT_PAGE__open_auth_if_no_auth_token';
import { ROUTE__base } from './ROUTE__base';

export function ROUTE__private(path: string, element: React.ReactNode) {
  return ROUTE__base(path, <LAYOUT_PAGE__open_auth_if_no_auth_token page={element} />);
}
